import { action, observable, computed, makeObservable } from 'mobx';
import { getWindowInnerWidth } from 'src_common/common/mobx-utils/Services/window';

export class QuickBetState {
    private static instance: QuickBetState;

    public static getInstance(): QuickBetState {
        if (!QuickBetState.instance) {
            QuickBetState.instance = new QuickBetState();
        }
        return QuickBetState.instance;
    }

    @observable public isShowQuickBetInner: boolean = false;

    private constructor() {
        makeObservable(this);
    }

    @action public onUpdateQuickBet = (isShow: boolean): void => {
        this.isShowQuickBetInner = isShow;
    };

    @computed public get canBeVisibleQuickBet(): boolean {
        const innerWidth = getWindowInnerWidth();
        if (innerWidth !== null) {
            const maxResolutionForQuickbet = innerWidth <= 768;
            return maxResolutionForQuickbet;
        }
        return false;
    }

    @computed public get isVisibleQuickBet(): boolean {
        return this.canBeVisibleQuickBet && this.isShowQuickBet;
    }

    @computed public get isShowQuickBet(): boolean {
        return this.isShowQuickBetInner;
    }
}
